import { Button } from '@design-system/components/button/button';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import * as styles from './LibraryHint.css';

export type LibraryHintType = { title?: string; description?: string };

export const LibraryHint = (p: {
  hint: LibraryHintType | null;
  onApply: (hint: LibraryHintType) => void;
}) => {
  if (!p.hint) return null;

  return (
    <Tooltip
      title={<TooltipContent hint={p.hint} onApply={p.onApply} />}
      variant="dark"
      arrow={false}
      tooltipProps={{ maxWidth: '400px', minHeight: '100px' }}
    >
      <Typography
        as="p"
        className={sprinkles({ color: 'N-80' })}
        variant="body"
        size="small"
      >
        Do you want to apply the title/description from library?{' '}
        <Typography
          as="span"
          className={sprinkles({ color: 'P-60' })}
          variant="body"
          size="small"
        >
          Yes, use it
        </Typography>
      </Typography>
    </Tooltip>
  );
};

const TooltipContent = (p: {
  hint: LibraryHintType;
  onApply: (hint: LibraryHintType) => void;
}) => (
  <div className={styles.tooltipContent}>
    {p.hint.title && <Typography>{p.hint.title}</Typography>}
    {p.hint.description && <Typography>{p.hint.description}</Typography>}
    <div className={sprinkles({ display: 'flex', justifyContent: 'end' })}>
      <Button variant="text" onClick={() => p.onApply(p.hint)}>
        Use library content
      </Button>
    </div>
  </div>
);
